/** Picks v2 or v1 of the Cancelations Report based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import UserCancellationPage   from './UserCancellationPage';
import UserCancellationPageV2 from './v2/UserCancellationPageV2';

export default function UserCancellationPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? UserCancellationPageV2 : UserCancellationPage;
  return <Component {...props} />;
}
